import Save from '../views/units/save'
import List from '../views/units/list'
import Unit360View from '../views/units/360View.vue'

export default [
    {
        path: '/admin/units',
        name: 'units',
        component: List,
    },
    {
        path: '/admin/unit/:id?',
        name: 'unit-save',
        component: Save,
    }
]
